module.exports = require("process");;